'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribe = subscribe;

var _immutable = require('immutable');

/*
 * Subscribe a set of subscriptions to a given Redux store, API reducer, and Socket.io socket to a set of API channels
 * and models.
 *
 * Returns a list of unsubscribe function that can be used to unsubscribe from all the subscriptions.
 */
function subscribe(subscriptions) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$notifyCb = options.notifyCb,
      notifyCb = _options$notifyCb === undefined ? undefined : _options$notifyCb,
      _options$tag = options.tag,
      tag = _options$tag === undefined ? '' : _options$tag;


  var subscribeId = Symbol(tag); // Symbol is always unique, but we give it a nice tag name (if provided) so it looks nice in the debugger
  var unsubscribers = [];
  // Subscribe to the data
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = subscriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var subscription = _step.value;
      var channels = subscription.channels,
          onSubscribe = subscription.onSubscribe,
          onNotify = subscription.onNotify,
          onUnsubscribe = subscription.onUnsubscribe;

      var unsubscribe = subscribeSingle(subscribeId, channels, onSubscribe, onNotify, onUnsubscribe, notifyCb);
      unsubscribers.push(unsubscribe);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return (0, _immutable.List)(unsubscribers);
}

/*
 * Subscribe all the channels in a single subscription
 */
function subscribeSingle(subscribeId, channels, onSubscribe, onNotify, onUnsubscribe) {
  var notifier = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

  // First, subscribe the instance to the API.
  onSubscribe(subscribeId);

  // Next, optionally, make the notify callback for all of the specified channels.
  var unsubscribers = [];
  if (notifier !== undefined) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = channels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var channel = _step2.value;

        var unsubscribe = notifier.onSubscribe(subscribeId, channel, onNotify);
        unsubscribers.push(unsubscribe);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  unsubscribers = (0, _immutable.List)(unsubscribers);

  // Last, return the unsubscribe function for removing the socket channels and API reducer subscriptions.
  return function _unsubscriber() {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = unsubscribers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var unsubscriber = _step3.value;

        unsubscriber();
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    onUnsubscribe(subscribeId);
  };
}